var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-enter-top-title"})
}
var staticRenderFns = []

export { render, staticRenderFns }